import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import Stack from '@mui/material/Stack';

function Valuations({profile} :any) {
  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
       <p><strong>Preset Valuations</strong></p>
      </p>
      <div className="table-responsive">
        <table className="table table-striped table-sm">
          <thead>
            <tr>
              <th></th>
              <th><strong>Growth Rate</strong></th>
              <th><strong>Future PE</strong></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            { profile?.valuations.map((item =>
              <tr>
                <td>{item.ticker}</td>
                <td>{item.growth_rate}</td>
                <td>{item.future_pe}</td>
                <td>
                  <form>
                    <Stack direction="row" spacing={2}>
                      <Button href={"/ticker/" + item.ticker} size="small" variant="outlined" startIcon={<ShowChartIcon />}>View</Button>
                    </Stack>
                  </form>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  );
}

export default Valuations;
